export const AppConstants = {
  EDIT_DIALOG_RESULT_OK: "ok",
  EDIT_DIALOG_RESULT_CANCEL: "cancel",
}
